class CommentsManager {
  constructor(data) {
    this.data = data;
    this.partners = this.getPartners();
    this.activities = this.getActivities();
  }

  apiResponse() {
    return this.data;
  }

  getActivities() {
    return this.data.activity.map(([num, item]) => {
      return { partner_name: item, employee_count: num };
    });
  }

  getPartners() {
    return this.data.partners.map(([item, num]) => {
      return { partner_name: item, employee_count: num };
    });
  }
}

export default CommentsManager;
